import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import "flatpickr/dist/themes/material_green.css";
import "react-datetime/css/react-datetime.css";
import { useNavigate } from 'react-router-dom'
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ca';
import Flatpickr from "react-flatpickr";
import Moment from 'react-moment';
import { TipusFixatge } from '../ControlPresencia/TipusFixatge';
import { crearErrorAction, esborrarErrorAction, uiAmagarIncidenciesRestaHoresFiJornadaAction } from '../../actions/ui';
import { addIncidenciaRestaHoresUltimFixatge } from '../../actions/configIncidenciaAction';

// CANVI: llegeix cp.detallSetmana.fixatges_setmanals en lloc de cp.fixatgeDiaConsultat

export const FormulariIncidenciaRestaHoresFiJornada = ({ diaConsultat }) => {
  const dispatch = useDispatch();
  const navegacio = useNavigate();
  const [t, i18n] = useTranslation('generic');

  const { auth, ui, cp ,calendari} = useSelector(
    state => ({ auth: state.auth, ui: state.ui, cp: state.cp, calendari: state.calendari }),
    shallowEqual
  );
  const { loading, msgError } = ui;

  // Llegir fixatges del dia consultat des de detallSetmana
  let fixatgesDia = cp.detallSetmana?.fixatges_setmanals?.find(d => d.dia === diaConsultat)?.fixatges ?? [];
  console.log('fixatgesDia', fixatgesDia);
  if (fixatgesDia.length == 0) {
    fixatgesDia= calendari.detallMes.fixatgesMes?.find(d => d.dia === diaConsultat)?.fixatges ?? [];
  }
  const [tipusFixatge, setTipusFixatge]             = useState('');
  const [tipusFixatgeSortida, setTipusFixatgeSortida] = useState('');
  const [dataFixatgeSortida, setDataFixatgeSortida] = useState(new Date());
  const [dataFixatgeEntrada, setDataFixatgeEntrada] = useState(new Date());
  const [dataIniciMinSortida, setDataIniciMinSortida] = useState();
  const [dataFinalMaxSortida, setDataFinalMaxSortida] = useState();

  let idiomaDatetime = t('Generics.idiomaDatetime');
  let listFixatgesSortida = [];

  useEffect(() => {
    if (!auth.tokenJwt) navegacio('/');
  }, [auth]);

  // Construir llista de parells entrada+sortida (per seleccionar el parell a modificar)
  if (fixatgesDia.length >= 2) {
    const listItems = fixatgesDia.map(d => ({
      IdFixatge: d.IdFixatge,
      IdTipus_Fixatge: d.IdTipus_Fixatge,
      IdTipusIncidencia_Fixatge: d.IdTipusIncidencia_Fixatge,
      DataHora_Fixatge: d.DataHora_Fixatge
    }));

    for (let index = 0; index < listItems.length - 1; index += 2) {
      const { IdTipus_Fixatge: t1, IdTipusIncidencia_Fixatge: iti1, DataHora_Fixatge: dh1 } = listItems[index];
      const { IdFixatge: id2, IdTipus_Fixatge: t2, IdTipusIncidencia_Fixatge: iti2, DataHora_Fixatge: dh2 } = listItems[index + 1];

      listFixatgesSortida.push(
        <div className='form-check mb-1' key={id2}>
          <input type="radio" id={`tipusIncidenciaRadio${id2}`} className="form-check-input"
            name="tipusIncidenciaSortida" value={id2}
            onChange={(e) => { setTipusFixatgeSortida(e); setDataIniciMinSortida(dh1); setDataFinalMaxSortida(dh2); setDataFixatgeEntrada(dh1); }} />
          <label className="form-check-label" htmlFor={`tipusFixatgeRadio${id2}`}>
            <TipusFixatge idTipusFixatge={Number(t1)} idTipusIncidencia={Number(iti1)} /> - <Moment format="HH:mm" date={dh1} />{' '}
            <TipusFixatge idTipusFixatge={Number(t2)} idTipusIncidencia={Number(iti2)} /> - <Moment format="HH:mm" date={dh2} />
          </label>
        </div>
      );
    }
  }

  const handleUltimFixatge = (e) => {
    e.preventDefault();
    dispatch(addIncidenciaRestaHoresUltimFixatge(
      tipusFixatgeSortida.target._wrapperState.initialValue,
      auth.tokenJwt,
      moment(diaConsultat).format('YYYY-MM-DD ') + moment(dataFixatgeEntrada).format('HH:mm:ss'),
      moment(diaConsultat).format('YYYY-MM-DD ') + moment(dataFixatgeSortida).format('HH:mm:ss')
    ));
    dispatch(uiAmagarIncidenciesRestaHoresFiJornadaAction());
  };

  return (
    <>
      {fixatgesDia.length >= 2 &&
        <div className='row'>
          <h5>{t('FormulariIncidencies.crear')}</h5>
          {i18n.language === 'ca'
            ? <p>Modifica el darrer fixatge del dia</p>
            : <p>Modifica el último fichaje del día</p>
          }
          <div className='mx-4'>{listFixatgesSortida}</div>

          {tipusFixatgeSortida !== '' &&
            <div className='container mt-5'>
              <div className="row mb-4">
                <div className='col-md-4'>
                  <label className="form-label align-right">Hora de la nova sortida</label>
                </div>
                <div className='col-md-8'>
                  <Flatpickr
                    options={{ dateFormat: "H:i ", enableTime: true, noCalendar: true, time_24hr: true,
                      locale: idiomaDatetime, minDate: moment(dataIniciMinSortida).format('HH:mm:ss'), maxDate: moment(dataFinalMaxSortida).format('HH:mm:ss') }}
                    data-enable-time value={new Date(dataFixatgeSortida)}
                    onChange={(d) => setDataFixatgeSortida(new Date(d))} />
                </div>
              </div>
              <div className="text-center">
                <button onClick={handleUltimFixatge} className="btn btn-primary btn-sm m-1" disabled={loading}>
                  {t('FormulariIncidencies.btnDadesIncidencia')}
                </button>
              </div>
            </div>
          }
        </div>
      }
    </>
  );
};

export default FormulariIncidenciaRestaHoresFiJornada;